export enum SubscriptionState {
  DEFAULT = 'default',
  NONE = 'none',
  CUSTOM_TRIAL_EXPIRED = 'customTrialExpired',
  EXPIRED = 'expired',
}
